import { Col, Card, Row, Heading } from 'mymoria-ui/components';
import { styled } from 'mymoria-ui/utils';
import React from 'react';
import { global } from 'data';

const { shutdown } = global;

const FlexCol = styled(Col)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
`;

const Shutdown = () => (
  <Card>
    <Row flexDirection="column" alignItems="center">
      <FlexCol width={1}>
        <Heading.Heading3 mb="1rem">{shutdown}</Heading.Heading3>
      </FlexCol>
    </Row>
  </Card>
);

export default Shutdown;
